import Vue from 'vue'
import axios from '../plugins/axios'

Vue.prototype.$http = axios

const global = {
    namespaced: true,
    state: {
        leftMenuClosed: null
    },
    mutations: {
        setLeftMenuClosed(state, value) {
            state.leftMenuClosed = value
        }
    }
}

export default global